import { grayColor, DodgerBlueColor } from "../../cmsMainStyle";

const detailReportDropzoneContentStyle = (theme) => ({
  dropzoneArea: {
    // background: grayColor[1]
  },

  buttonArea: {
    textAlign: "center",
    paddingTop: theme.spacing(5),
  },

  icon: {
    background: DodgerBlueColor[11],
    "&:hover": {
      background: DodgerBlueColor[13],
    },
  },
});

export default detailReportDropzoneContentStyle;
